import { createAuthClient } from "better-auth/react";

const baseURL =
  typeof window !== "undefined"
    ? `${window.location.origin}/api/auth`
    : "http://localhost:8787/api/auth";

export const authClient = createAuthClient({
  baseURL,
  socialProviders: {
    google: true,
  },
});
